
import DragUpload from '@/components/util/DragUpload.vue';
import List from '@/components/util/List.vue';
import StatusStepper from '@/components/orders/StatusStepperComponent.vue';
import DetailLayout from '@/components/system/DetailsLayout.vue';
import PhotoCarousel from '@/components/orders/PhotoCarousel.vue';
import BuildingDisplayComponent from '@/components/system/BuildingDisplayComponent.vue';
import Location2DisplayComponent from '@/components/system/Location2DisplayComponent.vue';
import QuickMessagePicker from '@/components/system/QuickMessagePicker.vue';

import { Component, Prop, Vue } from 'vue-property-decorator';

import {
  CommentKind,
  FieldMetadata,
  Property,
  Workorder,
  WorkordersApi
} from 'performo-api';

import { mapGetters } from 'vuex';
import { handleApiError } from '@/ApiHelpers';

@Component({
  components: {
    List,
    StatusStepper,
    PhotoCarousel,
    DragUpload,
    DetailLayout,
    BuildingDisplayComponent,
    Location2DisplayComponent,
    QuickMessagePicker
  },
  computed: mapGetters({
    currentProperty: 'currentProperty',
    ordersApi: 'ordersApi'
  })
})
export default class RequesterDetail extends Vue {
  private ordersApi!: WorkordersApi;

  private survey = { message: '', rating: 0 };
  private commentText = '';
  private customFields: FieldMetadata[] = [];
  private customFieldsLoading = true;

  private currentProperty!: Property;

  get isMobile(): boolean {
    return this.$vuetify.breakpoint.mobile;
  }
  get photoUploadInstructions(): string {
    return this.isMobile ? 'Upload photos' : 'Drag your photos here to upload';
  }
  get orderNotesDisplay() {
    if (!this.order.notes) return '';
    return this.order.notes.replace(/(?:\r\n|\r|\n)/g, '<br>');
  }
  get showSubmitSurvey() {
    return this.survey.rating !== 0;
  }

  private filterExtendedData() {
    this.customFieldsLoading = true;
    this.ordersApi.getCustomFields().then((fields) => {
      if (!this.order.extendedData) {
        this.customFieldsLoading = false;
        return;
      }
      this.customFields = fields;
      console.log(this.order);

      const fieldNames = fields.map((field) => field.name);
      let keysToRemove = Object.keys(this.order?.extendedData).filter(
        (key) => !fieldNames.includes(key)
      );
      for (const keyToRemove of keysToRemove) {
        delete this.order.extendedData?.[keyToRemove];
      }
      this.order.extendedData = { ...this.order.extendedData };
      this.customFieldsLoading = false;
    });
  }

  private mounted() {
    this.filterExtendedData();
  }

  private addPublicComment() {
    this.addComment(this.commentText, 'public');
  }

  private async addComment(text: string, kind: string) {
    if (text && text.length > 0) {
      try {
        await this.ordersApi.addComment({
          workorderCommentCommand: {
            commentText: text,
            workorderId: this.order.workorderId,
            commentTime: new Date(),
            kind:
              kind === 'public' ? CommentKind.NUMBER_1 : CommentKind.NUMBER_2
          }
        });
        this.refresh();
        this.commentText = '';
      } catch (error) {
        handleApiError(error);
      }
    }
  }

  private messageClickedHandler(message: string) {
    this.commentText = message;
  }

  private successHandler(data: Workorder) {
    if (this.refresh) {
      this.refresh(data);
    }
  }

  private errorHandler(error: string | Error) {
    console.log(error);
  }

  @Prop({ required: true })
  private order!: Workorder;

  @Prop({ required: false, type: Function })
  private refresh!: (response?: Workorder) => Promise<void>;
}
